import React from 'react';

function Svg({ size = 16, strokeWidth = 1.75, fill = 'none', stroke = 'currentColor', children }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={fill}
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
        >
            {children}
        </svg>
    );
}

const icon = (children, defaults) => function Icon(props) {
    return <Svg {...defaults} {...props}>{children}</Svg>;
};

export const IconChevronDown = icon(<path d="m6 9 6 6 6-6" />);
export const IconChevronRight = icon(<path d="m9 18 6-6-6-6" />);
export const IconX = icon(<><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>);
export const IconMinus = icon(<path d="M5 12h14" />);
export const IconPlus = icon(<><path d="M5 12h14" /><path d="M12 5v14" /></>);
export const IconMessageCircle = icon(<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />);
export const IconBarChart = icon(<><path d="M18 20V10" /><path d="M12 20V4" /><path d="M6 20v-6" /></>);
export const IconArrowUp = icon(<><path d="m5 12 7-7 7 7" /><path d="M12 19V5" /></>);
export const IconArrowDown = icon(<><path d="M12 5v14" /><path d="m19 12-7 7-7-7" /></>);
export const IconRefresh = icon(
    <>
        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
        <path d="M21 3v5h-5" />
        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
        <path d="M3 21v-5h5" />
    </>,
);
export const IconCopy = icon(
    <>
        <rect x="8" y="8" width="14" height="14" rx="2" />
        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
    </>,
);
export const IconCheck = icon(<path d="M20 6 9 17l-5-5" />);
